/**
 * Environment tag shared by Datadog RUM (`env`) and Sentry (`environment`) so
 * both tools always label the same deploy identically. Each tool is enabled
 * only outside local development, so anything that isn't a Vercel preview is
 * production. Kept side-effect free so either module can import it without
 * triggering the other's init.
 */
export function monitoringEnvironment(
  vercelEnv: string | undefined,
): "preview" | "production" {
  return vercelEnv === "preview" ? "preview" : "production";
}
